import { useContext } from "react";

import { ThemeContext } from "./ThemeContext";

export const useThemeProvider = () => {
  const theme = useContext(ThemeContext);

  if (!theme) {
    throw new Error("useThemeProvider must be used within a ThemeProvider");
  }

  return theme;
};
